module.exports = __webpack_public_path__ + "static/img/rmvb.e431df36.png";